import { z } from "zod/v4";

export const ReadmeLoginResponseBodySchema = z.object({
  redirect: z.string(),
});
export type ReadmeLoginResponseBodyType = z.infer<
  typeof ReadmeLoginResponseBodySchema
>;
